import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, PrinterIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { GUARANTEE_DAYS } from '../data/offer';
const miniBadges = ['6 Volumes', '5 Bonuses', '75 Printable Templates', 'Undated — start any week', 'Letter + A4', 'Works with whatever you already teach'];
const trustItems = [{
  Icon: LockIcon,
  label: 'Secure checkout'
}, {
  Icon: ZapIcon,
  label: 'Instant download'
}, {
  Icon: ShieldCheckIcon,
  label: `${GUARANTEE_DAYS}-day guarantee`
}, {
  Icon: PrinterIcon,
  label: '100% printable PDF'
}];
export function Hero() {
  return <header className="w-full bg-cream" data-id="element-134" data-mp="s9zz3hgnh6mq">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 pt-9 pb-14 sm:pt-14 sm:pb-20" data-id="element-135" data-mp="sd4aozwg34nf">
        <div className="grid lg:grid-cols-[1.05fr_0.95fr] gap-10 lg:gap-14 items-center" data-id="element-136" data-mp="nbydaoruat7k">
          <div data-id="element-137" data-mp="3d2tp5bt8kofl">
            <p className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-sage-tint text-sage border border-sage-soft text-[11px] sm:text-xs font-semibold uppercase tracking-[0.12em]" data-id="element-138" data-mp="3czfny6wb6l9q">
              <span aria-hidden="true" data-id="element-139" data-mp="3j6fx1mlet7c9">◆</span>
              Homeschool, Handled. — The operations system for the parent who
              runs it all
            </p>

            <h1 className="mt-6 font-serif font-black text-ink text-[34px] leading-[1.06] sm:text-5xl lg:text-[56px] lg:leading-[1.03] tracking-tight" data-id="element-140" data-mp="399jlt944m740">
              Run your whole homeschool on a twenty-minute weekly reset.{' '}
              <span className="text-sage" data-id="element-141" data-mp="30fya5yn9d5yt">
                Even after the weeks that fall apart.
              </span>
            </h1>

            <p className="mt-6 text-ink-soft text-base sm:text-lg leading-relaxed max-w-xl" data-id="element-142" data-mp="2qkdd8ex1qvvx">
              The complete six-volume operations system for families who already
              homeschool — the year, the week, the records, and the house around
              them. Set up in one afternoon. Kept alive in twenty minutes a
              week.{' '}
              <strong className="text-ink font-semibold" data-id="element-143" data-mp="2ljz6d076lrzh">
                Zero curriculum, by design.
              </strong>
            </p>

            <div className="mt-8" data-id="element-144" data-mp="nat83dklgolr">
              <CtaButton data-id="element-145" data-mp="najj9tbacnhn">Get Homeschool, Handled. — Instant Access</CtaButton>
            </div>

            <ul className="mt-7 flex flex-wrap gap-x-6 gap-y-3" data-id="element-146" data-mp="id050tel8app">
              {trustItems.map(({
              Icon,
              label
            }) => <li key={label} className="flex items-center gap-2 text-sm font-medium text-ink-soft" data-id="element-147" data-mp="deyjm1tovzb2">
                  <Icon className="w-4 h-4 text-vital" aria-hidden="true" data-id="element-148" data-mp="161jcj6ptcjgq" />
                  {label}
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl overflow-hidden border border-cream-dark shadow-card" data-id="element-149" data-mp="x14nbw9qak7y">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/9fad5bc9-d404-4f5c-9e44-07407c8ad54a.jpg" alt="The One-Page Command Center on a real kitchen fridge, with the weekly reset checklist beside it." className="w-full h-full object-cover" width={1264} height={843} loading="eager" data-id="element-150" data-mp="3lsysoz5l2mj2" />
          </div>
        </div>

        <ul className="mt-10 sm:mt-12 flex flex-wrap gap-2" data-id="element-151" data-mp="269r3nvyj5iak">
          {miniBadges.map(badge => <li key={badge} className="inline-flex items-center rounded-full bg-white border border-cream-dark px-3.5 py-2 text-xs sm:text-sm font-medium text-ink" data-id="element-152" data-mp="2b0zcoqvy71n7">
              {badge}
            </li>)}
        </ul>
      </div>
    </header>;
}